//"use strict";


require("jquery");
window.jQuery = window.$ = jQuery; //Needed for modules that require jquery




require("jquery.validate");
require("jquery.validate.unobtrusive");

var Globalize = require("globalize").Globalize;
require("bootstrap");
//require("../Plugins/ripple/ripple-includer.js"); //Udkommenteret Ripple indtil vi finder en løsning på fejlen i IE.
require("../Plugins/select2/select2-includer.js");
var toastr = require("toastr");
require("tablesorter");
require("tablesorter-widgets");
require("jquery.sidr");

var dropdownModule = require("dropdownModule");

window.visSuccessNotifikation = function (message) {
    toastr.success(message);
}

window.visFejlNotifikation = function (message) {
    toastr.error(message);
} 

window.visInfoNotifikation = function (message) {
    toastr.info(message);
}

$(document).ready(function () {

    $.ajaxSetup({ cache: false });

    dropdownModule.init();
    initTableFilters();
    extendBootstrapPopoverWithStayOnHoverExceptOnClick();
    initTablesorter();
    window.initPopovers();
    initBootstrapModalFocusOnFirstInput();
    initDatevalidation();
    initSidemenu();
    initSubmitOnChange();
    
    
    $("#change-organisation select").on("change", function () {
        var orgID = $(this).val();
        window.location = "/account/SkiftUc/" + orgID;
    });

    if (window.successMessage != undefined && window.successMessage.length > 0) {
        window.visSuccessNotifikation(window.successMessage);
    }
    if (window.infoMessage != undefined && window.infoMessage.length > 0) {
        window.visInfoNotifikation(window.infoMessage);
    }
    if (window.errorMessage != undefined && window.errorMessage.length > 0) {
        window.visFejlNotifikation(window.errorMessage);
    }


    //Vi skal lige have sørget for at validere hidden fields.

        $("form").each(function() {

            //If has dont validate hidden data attribute
            if ($(this).is("[data-dont-validate-hidden]") === false) {

                if ($(this).data("validator")) {
                    $(this).data("validator").settings.ignore = "";
                }
                
            } 

        });

        //Autofocus første element på siden
        $('form:first *:input[type!=hidden]:first').focus();

    $("[data-toggle='tooltip']").tooltip();
    
});

function initSidemenu() {

    var loaderHtml = $("<div style='width: 100%; text-align: center;'><img style='margin-top: 50px;width: 100px;'src='/Content/Images/loader.gif'/></div>");

    $('#haendelser-sidebar-trigger').sidr({
        name: 'haendelser-sidebar',
        side: 'right', 
        displace: false,
        onOpen: function () {

            var sidebar = $("#haendelser-sidebar-indhold");
            sidebar.html(loaderHtml);

            var url = $('#haendelser-sidebar-trigger').data("haendelser-url");

            $.get(url, function (data) {
                sidebar.html(data);

                $("#haendelser-luk-knap").click(function () {
                    $.sidr('close', 'haendelser-sidebar');
                });
    
                initTableFilters(); 
            });
        },
        source: function (name) {
            return "<div id='haendelser-sidebar-indhold'></div>";
        }
    });

    $('#kontekstmenu-sidebar-trigger').sidr({
        name: 'kontekstmenu-sidebar',
        side: 'right',
        displace: false,
        onOpen: function () {

            var sidebar = $("#kontekstmenu-sidebar-indhold");
            sidebar.html(loaderHtml);

            var url = $('#kontekstmenu-sidebar-trigger').data("kontekstmenu-url");

            $.get(url, function (data) {
                sidebar.html(data);

                $("#kontekstmenu-luk-knap").click(function () {
                    $.sidr('close', 'kontekstmenu-sidebar');
                });
            });
        },
        source: function (name) {
            return "<div id='kontekstmenu-sidebar-indhold'></div>";
        }
    });

    $(".sidebar-trigger").hover(function() {
        var $element = $(this);

        visSidebarTriggerMedTekst($element);
        window.setCookie("sidebar-vist", "", 10, true);
    }, function () {
        var $element = $(this);
        skjulSidebarTriggerMedTekst($element);
    });

    if (window.getCookie("sidebar-vist") === undefined) {

        $(".sidebar-trigger").each(function() {
            visSidebarTriggerMedTekst($(this));
        });
    } 
}

function visSidebarTriggerMedTekst($element) {

    if ($element.find(".hover-text").length === 0) {
        var tekst = $element.data("hover-text");
        var tekstHtml = $("<span class='hover-text'> " + tekst + "</span>");

        $element.append(tekstHtml);
    }
    $element.animate({ width: "150" }, "fast");
}

function skjulSidebarTriggerMedTekst($element) {

    $element.animate({ width: "60" }, "fast");
    $element.find(".hover-text").remove();
}

function initDatevalidation() {
    jQuery.validator.addMethod('date',
        function (value, element) {

            var date = Globalize.parseDate(value, "dd-MM-yyyy");
            var dateIsValid = date != null;

            return dateIsValid;
        });
}

window.initTableClasses = function() {
    initTableFilters();
    initTablesorter();
}
 
function initTableFilters()
{
    $('table.searchable').each(function () {

        var table = $(this);

        var input = $('<input>');

        input.attr('placeholder', 'Tast for at søge i listen...');
        input.attr('class', 'form-control input-sm');
        input.attr('style', 'border-top: 0; border-left: 0; border-right: 0; border-bottom-left-radius: 0; border-bottom-right-radius: 0;');
        input.insertBefore(table);

        input.on("keyup", function() {

            var searchInput = $(this);

            var searchableTable = searchInput.next("table.searchable").first();

            var rowsToSearch = searchableTable.find("tbody tr");
            rowsToSearch.hide();

            var searchForValues = searchInput.val().toLowerCase().split(" ");

            var rowsToShow = rowsToSearch.filter(function () {

                var shouldShow = true;

                var textInRow = $(this).find("*").not(".not-searchable, .not-searchable *").text().toLowerCase();
                for (var i = 0; i < searchForValues.length; i++) {
                    var searchValue = searchForValues[i];

                    if (textInRow.indexOf(searchValue) < 0) //Returns -1 if textinRow doesn't contain searchValue 
                        shouldShow = false;
                }

                return shouldShow;
            });

            rowsToShow.show();
        });
    });


} 

function initTablesorter() {

    $.tablesorter.themes.bootstrap = {
        // these classes are added to the table. To see other table classes available,
        // look here: http://getbootstrap.com/css/#tables
        table: '',
        caption: 'caption',
        // header class names
        header: '', // give the header a gradient background (theme.bootstrap_2.css)
        sortNone: '',
        sortAsc: '',
        sortDesc: '',
        active: '', // applied when column is sorted
        hover: '', // custom css required - a defined bootstrap style may not override other classes
        // icon class names
        icons: '', // add "icon-white" to make them white; this icon class is added to the <i> in the header
        iconSortNone: 'unsorted-icon fa fa-sort', // class name added to icon when column is not sorted
        iconSortAsc: 'fa fa-sort-asc', // class name added to icon when column has ascending sort
        iconSortDesc: 'fa fa-sort-desc', // class name added to icon when column has descending sort
        filterRow: '', // filter row class; use widgetOptions.filter_cssFilter for the input/select element
        footerRow: '',
        footerCells: '',
        even: '', // even row zebra striping
        odd: ''  // odd row zebra striping
    };

    var tableSorterOptions = {
        theme: "bootstrap",

        widthFixed: true,

        headerTemplate: '{content} {icon}', // new in v2.7. Needed to add the bootstrap icon!

        // widget code contained in the jquery.tablesorter.widgets.js file
        // use the zebra stripe widget if you plan on hiding any rows (filter widget)
        widgets: ["uitheme"]


    };


    $("table.sortable").tablesorter(tableSorterOptions);
}


window.validate = function (callingElement, callbackIfValid, argumentForCallback) {

    var formToValidate = $(callingElement).closest("form");

    formToValidate.validate();

    //If valid, run callback
    if (formToValidate.valid()) {
        callbackIfValid(argumentForCallback);
    }
}

window.activateValidationForFormChildren = function (form) {

    jQuery.validator.unobtrusive.parse(form);

    $(form).find("[data-val='true']").each(function (index, element) {
        jQuery.validator.unobtrusive.parseElement(element);
    });
}

function extendBootstrapPopoverWithStayOnHoverExceptOnClick() {

    var originalLeave = $.fn.popover.Constructor.prototype.leave;
    $.fn.popover.Constructor.prototype.leave = function (obj) {
        var self = obj instanceof this.constructor ?
            obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data('bs.' + this.type);
        var container, timeout;

        originalLeave.call(this, obj);

        if (obj.currentTarget) {
            container = $(obj.currentTarget).siblings('.popover');
            timeout = self.timeout;

            // Ved klik på knapper og links
            container.find("button, a").one('click', function (event) {

                if ($(this).data("stoppropagation") !== undefined) {
                event.stopPropagation();
                }
                
                // Skjul alle popovers ved click på knap i popover
                $(".has-popover").popover("hide");
                
            });

            container.one('mouseenter', function () {
                //We entered the actual popover – call off the dogs
                clearTimeout(timeout);
                //Let's monitor popover content instead
                container.one('mouseleave', function () {
                    $.fn.popover.Constructor.prototype.leave.call(self, self);
                });
            });
        }
    };

}


function initBootstrapModalFocusOnFirstInput() {

    $('.modal').on('shown.bs.modal', function () {
        $(this).find("input").first().focus();
    });
}


function initSubmitOnChange() {
    $('.submit-on-change').change(function () {
        $(this).closest("form").submit();
    });
}


window.initPopovers = function()
{
    $("[data-popover]").each(function () {

        var erInitialiseret = $(this).data("popover-is-intialized");

        if (erInitialiseret === undefined) {
            $(this).popover({
                html: true,
                trigger: 'hover',
                animation: false,
                delay:
                {
                    show: 100,
                    hide: 200
                },
                content:
                    function () {
                        var contentDiv = $(this).next(".popover-content");

                        return contentDiv.html();
                    }
            }).addClass("has-popover");

            $(this).data("popover-is-intialized", true);
        }
    });
}

window.submitClosestForm = function(buttonElement) {

    var $form = $(buttonElement).closest("form");

    $form.submit();
}


window.setCookie = function(name, value, expiresInDays, gælderForHeleSiden) {
    var date = new Date();
    date.setTime(date.getTime() + (expiresInDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    var cookieStreng = name + "=" + value + "; " + expires;

    if (gælderForHeleSiden === true)
        cookieStreng += "; path=/";

    document.cookie = cookieStreng;
}

window.getCookie = function(name) {
    name = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return undefined;
}





/*****************
 ** WEBPACK FOOTER
 ** ./Content/Scripts/SharedLayout.js
 ** module id = 0
 ** module chunks = 15
 **/